import { computed } from "vue";
import { useRoute } from "vue-router";
import { authService } from "@/services/authService";
import { getGuidesForRoute } from "@/help/registry";
const AUTH_ROUTE_NAMES = new Set([
    "login",
    "register",
    "password-recovery",
    "magic-link",
    "callback",
]);
export const useContextualInteractiveGuides = () => {
    const route = useRoute();
    const contextualGuides = computed(() => {
        const routeName = typeof route.name === "string" ? route.name : "";
        if (!routeName || AUTH_ROUTE_NAMES.has(routeName))
            return [];
        return getGuidesForRoute(routeName);
    });
    const showInteractiveGuides = computed(() => authService.isAuthenticated() && contextualGuides.value.length > 0);
    return {
        contextualGuides,
        showInteractiveGuides,
    };
};
